export const EVENT_DETAILED_METRICS_QUERY_KEY =
  'EventTable.getDetailedMetricsQuery';
